var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        title: _vm.title,
        top: "10vh",
        width: "70%",
        "max-height": "500",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "batch-select-footer" },
                [
                  _c("span", { staticClass: "filesize-text file-limit-tip" }, [
                    _vm._v(_vm._s(_vm.getSizeFormat)),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.close } },
                    [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      attrs: {
                        size: "mini",
                        disabled: _vm.selectData.length === 0,
                        loading: _vm.loading,
                      },
                      on: { click: _vm.onConfirmClick },
                    },
                    [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "filelist-container" },
        [
          _c("div", { staticClass: "filter-row" }, [
            _c("div", { staticClass: "filter-row-left" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.getUser.userType === "1",
                      expression: "getUser.userType === '1'",
                    },
                  ],
                  staticClass: "filter-item",
                },
                [
                  _c("div", { staticClass: "filter-label" }, [
                    _vm._v(_vm._s(_vm.$t("table_column_lable_milestone"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "filter-value" },
                    [
                      _c("el-cascader", {
                        staticClass: "section-title-cascader",
                        attrs: {
                          options: _vm.milestoneColumns,
                          size: "mini",
                          props: {
                            value: "id",
                            label: "milestoneName",
                            children: "childMilestoneBO",
                          },
                          clearable: "",
                        },
                        model: {
                          value: _vm.filter.milestone,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "milestone", $$v)
                          },
                          expression: "filter.milestone",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c("div", { staticClass: "filter-item" }, [
                _c("div", { staticClass: "filter-label" }, [
                  _vm._v(_vm._s(_vm.$t("fileNameKeyword"))),
                ]),
                _c(
                  "div",
                  { staticClass: "filter-value" },
                  [
                    _c("el-input", {
                      attrs: { size: "mini", clearable: "" },
                      model: {
                        value: _vm.filter.uploadFilename,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "uploadFilename", $$v)
                        },
                        expression: "filter.uploadFilename",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "filter-item" }, [
                _c(
                  "div",
                  { staticClass: "filter-value" },
                  [
                    _c("el-date-picker", {
                      staticClass: "search-dateRange",
                      attrs: {
                        type: "daterange",
                        "range-separator": "~",
                        "start-placeholder": _vm.$t("file_upload_start_date"),
                        "end-placeholder": _vm.$t("file_upload_end_date"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.filter.uploadDateRange,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "uploadDateRange", $$v)
                        },
                        expression: "filter.uploadDateRange",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "filter-item" }, [
                _c(
                  "div",
                  { staticClass: "filter-value" },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "search-uploadBy",
                        attrs: {
                          placeholder: _vm.$t("UPLOAD_BY"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.filter.createBy,
                          callback: function ($$v) {
                            _vm.$set(_vm.filter, "createBy", $$v)
                          },
                          expression: "filter.createBy",
                        },
                      },
                      _vm._l(
                        _vm.filelist
                          .map((v) => v.createBy)
                          .reduce((pre, v, k, arr) => {
                            !pre.includes(v) ? pre.push(v) : ""
                            return pre
                          }, []),
                        function (v, k) {
                          return _c("el-option", {
                            key: k,
                            attrs: { label: v, value: v },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "filter-row-right" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { size: "mini" },
                    on: { click: _vm.onSelectClick },
                  },
                  [_vm._v(_vm._s(_vm.$t("COMMON_CHOOSE")))]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              ref: "fileTable",
              attrs: {
                data: _vm.pageData,
                border: "",
                "max-height": "500",
                "row-class-name": _vm.tableRowClassName,
              },
              on: { "selection-change": _vm.onTableSelectChange },
            },
            [
              _c("el-table-column", {
                attrs: { width: "65" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          [
                            _c("el-checkbox", {
                              on: { change: _vm.onAllSelectChange },
                              model: {
                                value: _vm.calcAllSelect,
                                callback: function ($$v) {
                                  _vm.calcAllSelect = $$v
                                },
                                expression: "calcAllSelect",
                              },
                            }),
                            _vm._v(
                              "\n                        (" +
                                _vm._s(_vm.selectData.length) +
                                ")\n                    "
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-checkbox", {
                          attrs: { value: _vm.calcIsChecked(scope.row) },
                          on: {
                            change: (e) => _vm.onSelectionChange(e, scope.row),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  label: _vm.$t("COMMON_ENTITY"),
                  prop: "cur.entityName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DOWNLOAD_FILE_NAME"),
                  "header-align": "center",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                  prop: "uploadFilename",
                },
              }),
              _vm.getUser.userType === "1"
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("table_column_lable_milestone"),
                      "header-align": "center",
                      "min-width": "130",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.multiMilestoneName) +
                                  "\n                    "
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.accessFlag == "0",
                                      expression: "scope.row.accessFlag == '0'",
                                    },
                                  ],
                                  staticClass: "forkpmgonly",
                                },
                                [_vm._v(_vm._s(_vm.$t("for_kpmg_only")))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2934592705
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DOWNLOAD_SIZE"),
                  "header-align": "center",
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("fileSize")(scope.row.size)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DOWNLOAD_TIME"),
                  "header-align": "center",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm._f("formatDateTime")(
                                scope.row.lastDownloadDate
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DOWNLOAD_BY"),
                  prop: "lastDownloadBy",
                  "header-align": "center",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("UPLOAD_TIME"),
                  "header-align": "center",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm._f("formatDateTime")(scope.row.createDate)
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("UPLOAD_BY"),
                  prop: "createBy",
                  "header-align": "center",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "action",
                  width: "70",
                  "show-overflow-tooltip": "",
                  align: "center",
                  label: _vm.$t("COMMON_DELETE"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.allowDelete(scope.row)
                          ? _c("i", {
                              staticClass: "el-icon-delete delete",
                              on: {
                                click: function ($event) {
                                  return _vm.onDeleteClick(scope.row)
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              total: _vm.filelist.length,
              "page-size": _vm.pageSize,
              "page-sizes": [10, 50, 100],
              layout: "prev, pager, next, sizes, total",
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }